import { UPDATE_ROL_USER } from "../graphql/mutations/role/role";
import { ANULL_USER, CREATE_USER ,UP_USER} from "../graphql/mutations/user/mutations";
import { GET_LIST_USER_ROLE, GET_PERMISSION_USER, GET_ROL } from "../graphql/query/role/query";
import { COUNT_PARAMS , COUNT_TECHNICIAN , COUNT_CLIENT , COUNT_SERVICE, COUNT_REQUEST } from "../graphql/query/user/query"
import { apiRequests } from "../services/api";

/** QUERIES */
export const conteoParams = async () => {
    try{
        const response = await apiRequests(COUNT_PARAMS);
        return {
            success:true,
            message:response.data.countParams.message,
            cont:response.data.countParams.conteo
        };
    } catch (error) {
        console.error("Error al conteo de datos:" , error);
        return [];
    }
};

export const contTechnician = async () => {
    try {
        const response  =await apiRequests(COUNT_TECHNICIAN);
        return {
            success:true,
            message:response.data.countTechnicianDashboard.messge,
            cont:response.data.countTechnicianDashboard.countTech
        }
    } catch (e) {
        console.error("Error al conteo de datos:" , e);
        return [];
    }
}

export const contClient = async () => {
    try {
        const response  =await apiRequests(COUNT_CLIENT);
        return {
            success:true,
            message:response.data.getContClient.message,
            cont:response.data.getContClient.cont
        }
    } catch (e) {
        console.error("Error al conteo de datos:" , e);
        return [];
    }
}

export const contRequest = async () => {
    try {
        const response = await apiRequests(COUNT_REQUEST);
        if(response?.data?.countRequest){
            return {
                success:true ,
                message:response.data.countRequest.message,
                requestAll:response.data.countRequest.requestAll,
                conteo:response.data.countRequest.conteo
            }
        } else {
            return {
                success:false ,
                message:response.data.countRequest.message,
                requestAll:0,
                conteo:0
            }
        }
    } catch (err){
        console.warn('Las siguientes son las fallas :' , err);
        return [];
    }
}

export const contService = async () => {
    try {
        const response  =await apiRequests(COUNT_SERVICE);
       // console.log('123',response);
        return {
            success:true,
            message:response.data.getCountService.message,
            contall:response.data.getCountService.contAll,
            contState:response.data.getCountService.contState,
            contActivity:response.data.getCountService.contActivity
        }
    } catch (e) {
        console.error("Error al conteo de datos:" , e);
        return [];
    }
}

export const getRol = async () => {
    try {
        const response = await apiRequests(GET_ROL);
        //console.log(response.data.getRolAdmin.rol);
        return response.data.getRolAdmin.rol;
    } catch(error){
        console.error("Error al obtener roles:" , error);
        return [];
    }
};

export const getRolUser = async () => {
    try {
        const response = await apiRequests(GET_LIST_USER_ROLE);
        return response.data.getUserRol;
    }
    catch(error){
        console.log('Las fallas son las siguientes: ',error);
        return null;
    }
}

export const getPermissionUser = async (id_users) => {
    try{
        const variables = {
            id_users:id_users
        }
        const response = await apiRequests(GET_PERMISSION_USER,variables);
        //console.log(response)
        if(response.data.getPermission.status === 2){
            return response.data.getPermission;
        } else if (response.data.getPermission.status === 1){
            console.warn('mensaje' , response.data.message );
            return response.data.getPermission;
        }else{
            console.warn('mensaje' , response.data.message );
            return [];
        }
        
    }catch(error){
        console.log('Las fallas son las siguientes: ' , error);
        return null;
    }
}

/** MUTATIONS */

export const createUserRol = async ({userRequest})=>{
    try{
        const variables = {
            userRequest:{
                email:userRequest.email,
                password:userRequest.password,
                role:userRequest.role
            }
        };
        //console.log(variables);
        const response =  await apiRequests(CREATE_USER,variables);
        //console.log(response.data.createUser);
        if (response?.data?.createUser) {
            return {
                success: true, // ✅ Éxito
                message: "Registro exitoso",
                user: response.data.createUser
            };
        }

        return {
            success: false, // ❌ Falló la creación
            message: "Existe un usuario con el correo",
            user: null
        };
        
    } catch (error){
        console.error("Error al crear usuario + Rol: " , error);
        return [];
    }
 
}

export const updatePermissRoles = async (usrs,selectedPermissions) => {
    try {
        //console.log(selectedPermissions);
        const variables = {
            permiseRequest:{
                userId:usrs,
                permissions:selectedPermissions,
            }
        }
        //console.log('123',variables);
        const response = await apiRequests(UPDATE_ROL_USER,variables)
        //console.log('222222',response);
        return response.data.assignPermisseToUser;
    } catch (error) {
        console.warn('Se presentaron las siguientes fallas en el servidor: ',error);
        return null;
    }
}

export const anullUserRol = async (id_users)=>{
    try {
        const variables = {
            id_user:id_users
        }
        const response = await apiRequests(ANULL_USER,variables);
        
        return response.data.anullUserAdm;
    } catch (err) {
        console.warn('Se presnto la siguiente falla :' , err);
        return [];
    }
};

export const enableUserRol = async(id_users) => {
    try {
        const variables = {
            id_user:id_users
        };
        const response = await apiRequests( UP_USER,variables);
        return response.data.upUserAdm
    } catch (error) {
        console.warn('Se presento las siguientes fallas: ' , error );
        return [];
    }
};